<template>
  <b-container class="create">
    <society-form
      @form-submit="save"
      @cancel="cancel"
      :save-loading="saveLoading"
    />
  </b-container>
</template>

<!-- ----------------------------------------------------------------------- -->

<script>
import SocietyForm from '@/components/society/SocietyForm';
import {
  handleServerErrorWithValidation,
} from '@/helpers/ToastedHelper';
import { ADD_SOCIETY_ACTION } from '@/store';

export default {
  name: 'SocietyCreate',
  components: {
    SocietyForm,
  },
  data: function () {
    return {
      saveLoading: false,
    };
  },
  methods: {
    cancel: function() {
      this.$router.go(-1);
    },
    save: async function (data) {
      this.saveLoading = true;
      try {
        const society = await this.$store.dispatch(ADD_SOCIETY_ACTION, data);
        this.$toasted.success('Society stored', { duration: 3000 });
        this.$router.push(`/admin/society/edit/${society.id}`);
      } catch (response) {
        this.showErrors(response);
      } finally {
        this.saveLoading = false;
      }
    },
    showErrors(error) {
      handleServerErrorWithValidation(error, this.$toasted);
    },
  },
};
</script>

<!-- ----------------------------------------------------------------------- -->

<style lang="scss" scoped></style>
